// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const listTimesheetProposalsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listTimesheetProposalsQueryParamsSchema = z.object({
  status: z.optional(z.enum(["pending", "accepted", "rejected", "edited"]).describe("Filter by status")),
  date_from: z.optional(z.string().date().describe("Filter proposals on or after this date (YYYY-MM-DD)")),
  date_to: z.optional(z.string().date().describe("Filter proposals on or before this date (YYYY-MM-DD)")),
  timely_user_id: z.optional(z.number().int().describe("Filter proposals by Timely user id")),
  page: z.optional(z.number().int().describe("Page number (1-based)")),
  limit: z.optional(z.number().int().describe("Page size")),
}).optional();

export const listTimesheetProposalsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Proposals retrieved successfully
 */
export const listTimesheetProposals200Schema = z.object({
  proposals: z.array(z.object({
    id: z.coerce.string(),
    date: z.string().date(),
    status: z.enum(["pending", "accepted", "rejected", "edited"]),
    created_at: z.optional(z.coerce.string()),
    updated_at: z.coerce.string().nullish(),
    entry_count: z.optional(z.number().int()),
    total_duration_minutes: z.optional(z.number().int()),
  })),
  meta: z.optional(z.object({})),
});

export const listTimesheetProposalsQueryResponseSchema = z.lazy(() => listTimesheetProposals200Schema);
